export default {
    unassignedOrdersDescription: 'Los pedidos no asignados siempre están incluidos.',
    today: 'Hoy',
    tomorrow: 'Mañana',
    last7Days: 'Últimos 7 días',
    last2Weeks: 'Últimas 2 semanas',
    lastMonth: 'Último mes',
    last3Months: 'Últimos 3 meses',
    monthToDate: 'Mes hasta la fecha',
    quarterToDate: 'Trimestre hasta la fecha',
    yearToDate: 'Año hasta la fecha',
    onlyUnassignedOrders: 'Solo pedidos no asignados',
    selectMode: 'Seleccionar modo',
    selectDateFieldPlaceholder: 'Seleccionar un campo de fecha...',
    reset: 'Restablecer',
    selectStatuses: 'Seleccionar estado(s)',
    selectDistributionZones: 'Seleccionar terminal(es)',
    selectClients: 'Seleccionar cliente(s)',
    firebase10Limit: 'Límite de 10',
    distributionZones: 'terminales',
    selectCategories: 'Seleccionar categoría(s)',
    selectManufacturers: 'Seleccionar fabricante(s)',
    customViews: 'Vistas personalizadas',
    fetchRecords: 'Obtener registros',
    goToRecords: 'Ir a registros',
    goToRoutes: 'Ir a rutas',
    goToMapFleet: 'Ir a mapa y flota',
    goToReport: 'Ir al informe',
    goToLiveConnect: 'Ir a Live Connect',
    goToAdmin: 'Ir a Admin',
    openSearch: 'Abrir búsqueda',
    createDedicatedOrder: 'Crear pedido dedicado',
    createSingleOrder: 'Crear pedido único',
    openBulkImport: 'Abrir importación masiva',
    checkBackLater: 'Vuelve más tarde para más',
    notApplicable: 'N/A',
    warning: 'Advertencia',
    language: 'Idioma',
    'Coming Soon': '¡Próximamente!',
    loadingMessage: 'IMPULSANDO MEJORES NEGOCIOS Y EXPERIENCIAS DE CLIENTE',
    loadingMessage2: 'La Solución Completa de Cadena de Suministro',
    loading: 'Cargando...',
    ItemNumber: 'Número de artículo',
    PrintQuantity: 'Cantidad de impresión',
    dateRegion: {
        Records: 'Registros',
        selectRequiredFields: 'Por favor seleccione el campo de fecha, cliente(s) y terminal(es)',
        orderCountToCheck: {
            one: '{{needToCheckDispatch}} pedido requiere atención',
            other: '{{needToCheckDispatch}} pedidos requieren atención',
        },
        buttons: {
            addUpload: 'Agregar/Subir',
            dedicatedOrder: 'Pedido dedicado',
            order: 'Pedido',
            upload: 'Subir',
        },
        supplyChain: {
            status: {
                pending: 'Pendiente',
                processing: 'En proceso',
                shipped: 'Enviado',
                delivered: 'Entregado',
            },
            inventory: {
                low: 'Poco stock',
                outOfStock: 'Sin existencias',
                available: 'En existencia',
            },
        },
        customerShipmentNotification: {
            title: 'Nuevos Envíos de Clientes',
            message: 'Los clientes han colocado envíos desde el portal',
            info: 'Cada envío generalmente incluye tanto recogida como entrega',
            closeAriaLabel: 'Cerrar notificación',
        },
    },
    nav: {
        header: {
            headerTitle: 'Registros',
        },
    },
    viewSettings: {
        deleteConfirmation: '¿Está seguro de que desea eliminar esta vista?',
        deleteWarning: 'Esto eliminará la vista "{{name}}" y toda su configuración.',
        delete: 'Eliminar',
        cancel: 'Cancelar',
        noViews: 'No se encontraron vistas',
        emptyState: {
            title: 'No hay vistas disponibles',
            description: 'Guarde sus filtros y rangos de fechas favoritos como vistas para acceder más tarde. Comparta vistas con partes externas para acceso rápido de solo lectura.',
            createFirstView: 'Cree su primera vista para comenzar'
        },
        shareLink: 'Compartir enlace',
        regions: 'Regiones',
        type: 'Tipo',
        clients: 'Clientes',
        dateRange: 'Rango de fechas',
        copyLink: 'Copiar enlace',
        sharingSettings: 'Configuración de compartir',
        warning: {
            accessClientZones: `No tiene acceso a los clientes o zonas de distribución de la vista.`,
            selectView: 'Debe crear una nueva vista o cargar la vista guardada desde el menú Vistas',
            bindClientZones: `Esta vista no tiene cliente y zona de distribución vinculados. Por favor, cree una nueva vista con vinculación`,
        },
        createNewView: 'Crear nueva vista',
        name: 'Nombre',
        enterName: 'Ingrese el nombre de la vista...',
        configurationSaved: 'Lo que guardará esta vista',
        visibleColumns: 'Columnas visibles',
        columnOrder: 'Orden de columnas',
        grouping: 'Agrupación',
        appliedFilters: 'Filtros aplicados',
        create: 'Crear vista',
        personal: 'Personal',
        shared: 'Compartido',
        bindClientDistributionzones: 'Guardar los clientes, zonas de distribución y rango de fechas actuales',
        bindClientZonesHelp: 'Los clientes y las zonas se vuelven a cargar con la vista. El rango de fechas se guarda solo para el enlace externo: en el portal la vista sigue el rango de fechas que tenga seleccionado. Sin esta opción, la vista usa los clientes y zonas que tenga en ese momento y solo aplica la opción de fecha de arriba.',
        columnLayoutSaved: 'El diseño de columnas actual — qué columnas son visibles y en qué orden aparecen — siempre se guarda.',
        shareExternally: 'Crear un enlace externo para compartir',
        shareExternallyHelp: 'Cualquier persona con el enlace puede abrir esta vista sin iniciar sesión. Puede añadir una contraseña, permitir la copia o desactivar el enlace en cualquier momento desde la configuración de la vista.',
        shareExternallyRequires: 'Active primero la opción de arriba. Un enlace compartido no tiene un usuario que haya iniciado sesión del que tomar clientes, zonas y un rango de fechas, por lo que solo funciona en una vista que haya guardado los suyos.',
        linkAvailableAfterCreate: 'El enlace se genera al crear la vista. Después puede copiarlo desde la configuración de la vista.',
        copyToClipboard: 'Enlace copiado al portapapeles. Ahora puede compartirlo',
        hasClientZones: 'Esta vista incluye clientes y zonas de distribución vinculados',
        passwordProtected: 'Esta vista está protegida por contraseña',
        error: {
            fetchFailed: 'Error al recuperar las vistas. Por favor, intente de nuevo.',
            copyFailed: 'Error al copiar el enlace. Por favor, intente de nuevo.',
            updateFailed: 'Error al actualizar la vista. Por favor, intente de nuevo.',
            deleteFailed: 'Error al eliminar la vista. Por favor, intente de nuevo.',
        },
        sharedView: {
            setPassword: {
                title: 'Se requiere una contraseña para ver este contenido',
                subTitle: 'Esta contraseña no es la misma que la contraseña de su cuenta de Shyftbase',
            },
            allowCopy: 'Permitir copia de datos',
            showAllFields: 'Mostrar todos los campos en registros expandidos',
            restrictAccess: 'Restringir por contraseña',
            disable: 'Desactivar enlace',
            enable: 'Activar enlace',
            notAvailable: {
                title: 'El enlace de compartir privado que intentó alcanzar no está disponible.',
                subTitle:
                    'El propietario de esta vista puede haber dejado de compartirla o eliminado. Por favor, contáctelo si necesita acceso.',
            },
            verifyPassword: 'Ingrese la contraseña para ver el contenido',
            wrongPassword: 'Contraseña incorrecta. Por favor, intente de nuevo.',
        },
        new: 'Nuevo',
        searchViews: 'Buscar vistas...',
        personalViews: 'Vistas personales',
        noPersonalViews: 'No se encontraron vistas personales.',
        sharedViews: 'Vistas compartidas',
        noSharedViews: 'No se encontraron vistas compartidas.',
        startWindow: 'Ventana de inicio',
        manageSharing: 'Configuración de la vista',
        sharedViaLink: 'Compartida mediante enlace externo',
        pullScope: 'Datos obtenidos',
        tableLayout: 'Diseño de la tabla',
        groupedBy: 'Agrupado por',
        filters: 'Filtros',
        notGrouped: 'Sin agrupar',
        noFilters: 'Sin filtros',
        dateBasis: 'Fecha',
        dateRangeExternalOnly: 'Solo lo usa el enlace externo. En el portal, esta vista siempre usa el rango de fechas que tenga seleccionado.',
        allZones: 'Todas las zonas de distribución',
        allClients: 'Todos los clientes',
        none: 'Ninguno',
        dateOptions: {
            today: 'Hoy',
            tomorrow: 'Mañana',
            yesterday: 'Ayer',
            none: 'Sin fecha guardada',
        },
        howToUpdate: {
            title: 'Cómo actualizar esta vista',
            layout: 'Diseño de la tabla — organice las columnas, la agrupación y los filtros en la cuadrícula como desee y luego haga clic en el icono de guardar de esta vista en el panel.',
            scope: 'Clientes, zonas y rango de fechas — solo las vistas guardadas con los clientes y zonas de distribución actuales los conservan. Cámbielos en el formulario de obtención, ejecute la obtención y haga clic en guardar. El rango de fechas guardado solo lo usa el enlace externo; en el portal esta vista siempre sigue el rango de fechas que tenga seleccionado.',
            fixed: 'El nombre, el modo y la asociación con clientes y zonas de distribución concretos se fijan al crear la vista. Cree una vista nueva para cambiarlos. (Esto no afecta al enlace para compartir de arriba, que puede activar y desactivar cuando quiera.)',
        },
    },
    dashboard: {
        title: 'Panel de Control',
        shyftbaseWatch: 'Monitor Shyftbase',
        shyftbaseWatchSubtitle: 'El monitor Shyftbase se activa una vez que se recopilan suficientes datos',
        shyftbaseWatchModal: {
            title: 'Monitor Shyftbase',
            message: 'El monitor Shyftbase se activa una vez que se recopilan suficientes datos.',
            buttonText: 'Ir a la Pestaña de Registros',
            closeAriaLabel: 'Cerrar modal',
        },
        operationsOverview: 'Resumen de Operaciones',
        orderCount: 'Recuento de Pedidos',
        unconfirmedPercent: 'No confirmado %',
        confirmedPercent: 'Confirmado %',
        invoicedPercent: 'Facturado %',
        activeRoutes: 'Rutas Activas',
        fleetUtilization: 'Utilización de Flota',
        avgDeliveryTime: 'Tiempo de Entrega Promedio',
        ordersNeedingAttention: 'Pedidos que requieren atención',
        noOrdersNeedAttention: 'Actualmente no hay pedidos que requieran atención.',
        noOrdersDescription: 'Cuando tenga pedidos que requieran acción, aparecerán aquí con detalles como:',
        noOrdersExamples: {
            addressVerification: 'Verificación de dirección necesaria',
            schedulingConflicts: 'Conflictos de programación de entrega',
            paymentVerification: 'Verificación de pago pendiente',
            specialHandling: 'Requisitos de manejo especial',
        },
        recommendations: 'Recomendaciones',
        noRecommendations: 'Aún no hay recomendaciones disponibles.',
        noRecommendationsDescription: 'A medida que su sistema recopile datos operativos, aparecerán aquí perspectivas impulsadas por IA que incluyen:',
        noRecommendationsExamples: {
            routeOptimization: 'Oportunidades de optimización de rutas',
            capacityPlanning: 'Sugerencias de planificación de capacidad',
            preventiveMaintenance: 'Alertas de mantenimiento preventivo',
            costSaving: 'Recomendaciones de ahorro de costos',
        },
        quickActions: {
            title: 'Acciones Rápidas',
            orderTable: {
                title: 'Tabla de Pedidos',
                description: 'Consola de operaciones y despacho en vivo',
            },
            uploadCsv: {
                title: 'Subir CSV',
                description: 'Importación masiva de pedidos',
            },
            liveConnect: {
                title: 'Live Connect',
                description: 'Aprobar/rechazar solicitudes de clientes',
            },
            mapFleet: {
                title: 'Mapa de Flota',
                description: 'Monitorear flota y rutas',
            },
            search: {
                title: 'Buscar',
                description: 'Búsquedas de atención al cliente',
            },
            reports: {
                title: 'Informes',
                description: 'Perspectivas operativas',
            },
            admin: {
                title: 'Admin',
                description: 'Configuración y ajustes',
            },
        },
        dataPending: {
            title: 'Cargando Datos...',
            description: 'Los datos operativos aparecerán aquí una vez que el sistema reciba y procese pedidos.',
        },
    },
    notification: {
        accessDenied: 'Acceso denegado. Por favor, verifique su nivel de acceso.',
        orderAssignment: 'Asignación de Pedido',
        assigned: 'Asignado',
        unassigned: 'No asignado',
        orderAssignmentSubtitle: 'Los pedidos no asignados aún no tienen una fecha objetivo',
        parametersRemoved: '{{parameters}} han sido eliminados ya que no son válidos para pedidos no asignados.',
    }    
}
